import React, { Component } from "react";

class BackToTop extends Component {
    constructor(props) {
        super();
        this.state = {
            showIcon: false,
            stayIcon: false,
        };
    }

    backtotop() {
        window.scrollTo(0, 0);
    }

    isTop(el) {
        return el.getBoundingClientRect().bottom <= window.innerHeight + 130;
      }

    componentDidMount() {
        window.addEventListener('scroll', e => this.handleNavigation(e));
    }

    handleNavigation = (e) => {
        const wrappedElement = document.getElementById('Footer');
        if (this.isTop(wrappedElement)) {
            this.setState({ stayIcon: true });
        }else{
            this.setState({ stayIcon: false });
        }
        if (window.scrollY >= 400) {
            this.setState({ showIcon: true });
        } else {
            this.setState({ showIcon: false });
        }
    };

    render() {

        return (
            <div className="position-fixed" style={{ bottom: this.state.stayIcon ? '463px' : '0.5rem', right: '0.5rem', zIndex: 9999, transition: '500ms' }}>
                <button className="btn btn-link text-center color-theme font-weight-bold text-decoration-none" style={{ opacity:this.state.showIcon ? 1 : 0, transition: '500ms' }} onClick={this.backtotop}><img src="./images/Homepage/Default.svg" alt="backtotop" /><br /> TOP</button>
            </div>
        )
    }
}

export default BackToTop;